import type {Conversation} from '@/client/mentor/ConversationsClient'
import {useAssistantStore} from '@/stores/assistant'
import {addDefaultErrorToast, addDefaultSuccessToast} from '@/utils/toast'
import {useI18n} from 'vue-i18n'
import {useModalStore} from '@/stores/modal'
import {useToastStore} from '@/stores/toast'

export function useDeleteConversation(deleteConversationById: (conversationId: string) => Promise<boolean>) {
  const assistantStore = useAssistantStore()
  const modalStore = useModalStore()
  const toastStore = useToastStore()
  const {t} = useI18n()

  function openDeleteConversationModal(conversation: Conversation, title: string) {
    modalStore.addModal(
      t('assistant.modal.delete.title'),
      t('assistant.modal.delete.message', {title}),
      {
        callback: async () => await submitConversationDeletion(conversation.id),
        label: t('assistant.actions.delete'),
        variant: 'warning',
      },
      {
        label: t('assistant.actions.cancel'),
        variant: 'warning-text',
      }
    )
  }

  async function submitConversationDeletion(conversationId: string) {
    try {
      await deleteConversationById(conversationId)

      if (assistantStore.activeConversationId === conversationId) {
        assistantStore.setActiveConversation(undefined)
      }

      addDefaultSuccessToast(toastStore, t)
    } catch (error) {
      addDefaultErrorToast(toastStore, t, error)
    }
  }

  return {
    openDeleteConversationModal,
  }
}
